import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router,
    RouterStateSnapshot,
    UrlTree,
} from '@angular/router';
import { TransactionsService } from 'app/core/transactions/transactions.service';
import { Observable, catchError, firstValueFrom, map } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class TransactionGuard implements CanActivate {
    constructor(
        private transactionService: TransactionsService,
        private router: Router
    ) {}
    async canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Promise<boolean> {
        const transactionId = route.queryParams['transactionId'];
        const publicTransactionId = route.queryParams['publicTransactionId'];

        if (!transactionId) {
            this.router.navigate(['404-not-found']);
        }

        try {
            const isExpired = await firstValueFrom(
                this.transactionService.checkIfTransactionExpired(transactionId)
            );
            const responseForIsExist: any = await firstValueFrom(
                this.transactionService.checkIfTransactionExist(
                    publicTransactionId
                )
            );
            const isTransactionExist = responseForIsExist.data;

            if (isExpired || !isTransactionExist) {
                this.router.navigate(['404-not-found']);
            }
            return true;
        } catch (error) {
            console.error('Error in TransactionGuard:', error);
            this.router.navigate(['404-not-found']);
        }
    }
}
